import axios from 'axios'
import Cookies from 'js-cookie'
import { API_BASE_URL } from '../config/api'

export class AuthService {
  static async checkAuthStatus() {
    try {
      const response = await axios.get('/auth/check')
      return {
        authenticated: response.data.authenticated,
        user: response.data.user
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Auth check failed:', error)
      throw error
    }
  }

  static async refreshToken() {
    try {
      const response = await axios.post('/auth/refresh')
      return response.data
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Token refresh failed:', error)
      throw error
    }
  }

  static async getCurrentUser() {
    try {
      const response = await axios.get('/auth/me')
      return response.data.user
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Get current user failed:', error)
      throw error
    }
  }

  static async loginWithEmail(email, password) {
    try {
      const response = await axios.post('/api/login', { email, password })

      if (response.data.user) {
        return { success: true, user: response.data.user }
      }

      return { success: false, error: 'Login failed' }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Login failed. Please try again.'
      return { success: false, error: errorMessage }
    }
  }

  static async registerWithEmail(userData) {
    try {
      const response = await axios.post('/api/register', userData)

      if (response.data.user) {
        return { success: true, user: response.data.user }
      }

      return { success: false, error: 'Registration failed' }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Registration failed. Please try again.'
      return { success: false, error: errorMessage }
    }
  }

  static loginWithGoogle() {
    window.location.href = `${API_BASE_URL}/auth/google`
  }

  static loginWithDiscord() {
    window.location.href = `${API_BASE_URL}/auth/discord`
  }

  static loginWithFacebook() {
    window.location.href = `${API_BASE_URL}/auth/facebook`
  }

  static loginWithMicrosoft() {
    window.location.href = `${API_BASE_URL}/auth/microsoft`
  }

  static async logout() {
    try {
      await axios.post('/auth/logout')

      // Clear any stored tokens/cookies (must match server cookie names)
      Cookies.remove('usertoken')
      Cookies.remove('refreshToken')

      // Clear all localStorage (profile data, theme, etc.)
      localStorage.clear()

      // Redirect to home or login page
      window.location.href = '/'
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Logout failed:', error)
      // Force logout even if request fails - clear everything anyway
      Cookies.remove('usertoken')
      Cookies.remove('refreshToken')
      localStorage.clear()
      window.location.href = '/'
    }
  }
}